import React from "react"
import { socialsdata } from '../constants/socials';
import { SocialIcon } from "react-social-icons/component"
import 'react-social-icons/youtube'
import 'react-social-icons/vimeo'
import 'react-social-icons/instagram'
import 'react-social-icons/mailto'

const Footer = () => {
  return (

    <div className="flec-col text-center w-full  pt-10 h-auto">
      <div className="w-full h-full hover:text-gray-300 duration-300">
          <a href='/' className="text-base uppercase text-designColor tracking-wider">
             Ronnee Swenton</a>
      </div>

      <div className="items-center w-full h-full flex flex-col py-8 pb-16 gap-8">
        <div className="socials flex gap-2">
        {
            socialsdata.map(({title, link})=>(
              <SocialIcon
                className="hover:bg-gray-800 hover:rounded-full hover:animate-spin "
                url={link}
                bgColor='var(--primary-color)'
                fgColor='transparent'
                style={{ width: 32, height: 32 }}
              />
            ))
        }
        </div>
      </div>
      <div>
        <p className="text-center text-xs text-gray-300">
          © 2025 RONNEE SWENTON. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer